import CreateReceiptButton from "./CreateReceiptButton";

export default CreateReceiptButton;
